<template>
  <div class="mobile-hospital-overlay">
    <button type="button" class="back-btn" @click="$emit('close')" title="Back">
      <ArrowLeft />
    </button>
    <SmallHeader>Hospital</SmallHeader>
    <template v-if="hospitalData">
      <header class="hospital-header">
        <div class="hospital-name">{{ hospitalData.name }}</div>
        <div class="hospital-address">{{ address }}</div>
        <div class="actions">
          <a
            v-if="hospitalData.url"
            :href="hospitalData.url"
            class="action-btn"
            target="_blank"
            rel="noreferrer noopener"
          >
            Website
          </a>
          <a
            v-if="hospitalData.phone"
            :href="`tel:${hospitalData.phone}`"
            class="action-btn"
          >
            <PhoneIcon class="action-icon" />
            Call
          </a>
          <a
            v-if="hospitalData.travel_information"
            :href="directionsLink"
            class="action-btn"
            target="_blank"
            rel="noreferrer noopener"
          >
            <CarIcon class="action-icon" />
            {{ Math.round(hospitalData.travel_information.travel_time / 60) }}
            min
          </a>
        </div>
      </header>
      <HospitalDetail :hospitalData="hospitalData" />
    </template>
  </div>
</template>

<script>
import ArrowLeft from '@/assets/arrow-left-large.svg';
import CarIcon from '@/assets/car-icon.svg';
import HospitalDetail from '@/components/ResultsMap/hospital-detail';
import PhoneIcon from '@/assets/phone-icon.svg';
import SmallHeader from '@/components/small-header';
import getAddress from '@/util/getAddress';

export default {
  components: { ArrowLeft, CarIcon, HospitalDetail, PhoneIcon, SmallHeader },
  props: {
    hospitalData: {
      type: Object,
      default: null,
    },
    userAddress: {
      type: String,
      default: '',
    },
  },
  computed: {
    address() {
      return this.hospitalData ? getAddress(this.hospitalData.location) : '';
    },
    directionsLink() {
      return this.hospitalData
        ? `https://www.google.com/maps/dir/${encodeURI(
            this.userAddress,
          )}/${encodeURIComponent(this.address)}`
        : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile-hospital-overlay {
  background: var(--gray);
  bottom: 0;
  left: 0;
  padding: var(--page-padding);
  position: fixed;
  overflow-y: auto;
  right: 0;
  top: 0;
}

.back-btn {
  left: var(--page-padding);
  position: absolute;
  top: var(--page-padding);
}

.small-header,
.hospital-header {
  text-align: center;
}

.small-header {
  margin-bottom: 32px;
}

.hospital-header {
  border-bottom: 1px solid var(--black);
}

.hospital-name {
  font-size: 34px;
}

.hospital-address {
  color: var(--dark-gray);
}

.actions {
  display: flex;
  margin: 24px -4px 32px;
  justify-content: center;
}

.action-btn {
  align-items: center;
  border: 1px solid var(--black);
  border-radius: 100px;
  color: var(--black);
  display: flex;
  margin: 0 4px;
  padding: 8px 16px 4px;
  text-decoration: none;
}

.action-icon {
  margin-right: 8px;
}

.hospital-detail /deep/ .hospital-sub-details {
  border-top-color: var(--dark-gray);
}
</style>
